<template>
    <div class="is-block">
        <div class="">
            <section class="px-4 py-4 search-changes">
                <app-search-bar
                    v-model="textSearch"
                    :filter.sync="selectedFilter"
                    :options="options"
                    class=""
                    :placeholder="$t('search_through_user')"
                />
            </section>
        </div>
        <div
            class="
                lb-project-changes
                has-scroll-y
                is-scroll-hidden
                px-4
            "
        >
            
            <article
                v-for="(item, index) in filteredItems" 
                :ref="item._id"
                :key="item._id"
                :class="{
                    'is-eduloc-red': item.action == 'ADD',
                    'is-eduloc-orange': item.action == 'REMOVE',
                    'is-eduloc-blue': item.action == 'MODIFY',
                    'is-clickable': item.project != item.object,
                }"
                class="message"
            >
                <div class="message-body" @click="processClick(item)" v-if="item.field!='TRIGGERS'">
                    <div class="lb-separator" v-if="index==0" />
                    <div class="px-4 py-4">
                        <p class="is-size-7 secondary-font">
                                {{
                                    new Date(item.created).toLocaleDateString('es', {
                                        hour: '2-digit',
                                        minute: '2-digit',
                                    })
                                }}
                        
                            - {{ usernameToShow(item) }}
                        <p class="primary-font">
                            {{
                                $store.getters.itemById(item.object) | extractTitle
                            }}
                        </p>
                        <p class="secondary-font">
                            {{
                                $t(
                                    'project.history.' +
                                        item.action +
                                        '_' +
                                        item.field
                                )
                            }}
                        </p>
                    </div>
                    <div class="lb-separator" />
                </div>
                
            </article>
        </div>
        <div class="action-buttons-container mb-2">
            <a @click="$emit('close')" class="button is-primary">
                <span class="icon is-small my-2"
                    ><i
                        class="mdi mdi-32px mdi-chevron-double-left"
                        aria-hidden="true"
                    ></i
                ></span>
            </a>
           
        </div>
    </div>
</template>

<script>
import AppSearchBar from '@/components/AppSearchBar';
import { Document } from 'flexsearch';
import _ from 'underscore';
export default {
    components: {
        AppSearchBar,
    },
    filters: {
        extractTitle(object) {
            return object ? object.title : '';
        },
    },
    data() {
        return {
            selectedFilter: 'FILTER_OPTION_PROJECT_CHANGES_ALL',
            textSearch: undefined,
            searchIndex: new Document({
                resolution: 3,
                tokenize: 'full',
                document: {
                    id: '_id',
                    index: ['owner:username', 'owner:name', 'owner:email'],
                },
            }),
            options: [
                'FILTER_OPTION_PROJECT_CHANGES_NEW',
                'FILTER_OPTION_PROJECT_CHANGES_REMOVED',
                'FILTER_OPTION_PROJECT_CHANGES_MODIFIED',
                'FILTER_OPTION_PROJECT_CHANGES_COMMENTS',
                'FILTER_OPTION_PROJECT_CHANGES_PARTICIPANTS',
            ],
        };
    },
    computed: {
        items() {
            return this.$store.getters.projectChanges;
        },
        filteredItems() {
            let items;
            this.items.forEach((item) => {
                this.searchIndex.remove(item);
            });
            switch (this.selectedFilter) {
                case 'FILTER_OPTION_PROJECT_CHANGES_NEW':
                    items = this.items.filter((item) => {
                        return item.action == 'ADD' && item.field == 'OBJECT';
                    });
                    break;
                case 'FILTER_OPTION_PROJECT_CHANGES_REMOVED':
                    items = this.items.filter((item) => {
                        return (
                            item.action == 'REMOVE' && item.field == 'OBJECT'
                        );
                    });
                    break;
                case 'FILTER_OPTION_PROJECT_CHANGES_MODIFIED':
                    items = this.items.filter((item) => {
                        return item.action == 'MODIFY' && item.project;
                    });
                    break;
                case 'FILTER_OPTION_PROJECT_CHANGES_COMMENTS':
                    items = this.items.filter((item) => {
                        return item.field == 'COMMENT';
                    });
                    break;
                case 'FILTER_OPTION_PROJECT_CHANGES_PARTICIPANTS':
                    items = this.items.filter((item) => {
                        return item.field == 'SHAREDWITH';
                    });
                    break;
                default:
                    items = this.items;
            }
            if (this.textSearch) {
                items.forEach((item) => {
                    this.searchIndex.add(item);
                });
                const result = this.searchIndex.search(this.textSearch);
                const ids = _.chain(result).pluck('result').flatten().value();
                return this.items.filter((item) => {
                    return _.contains(ids, item._id);
                });
            }

            return items;
        },
        filteredItemsLength() {
            return this.filteredItems.length;
        },
        windowSize() {
            return this.$mq;
        },
    },
    watch: {
        filteredItemsLength: {
            handler: function (newItems, oldItems) {
                if (newItems.length > 0) {
                    this.scrollToItem();
                }
            },
        },
        items: {
            handler: function () {
                //console.log('adding items to search', this.items.length);
                //this.searchIndex.add(this.items);
                this.items.forEach((item) => {
                    this.searchIndex.add(item);
                });
            },
            immediate: true,
        },
    },
    mounted() {
        this.$store.dispatch('fetchProjectChanges');
    },
    methods: {
        scrollToItem() {
            const lastMessage = _.first(this.filteredItems);
            if (lastMessage) {
                this.$nextTick(() => {
                    this.$refs[lastMessage._id][0].scrollIntoView();
                });
            }
        },
        processClick(item) {
            if (item.object != item.project) {
                this.$emit('openObject', { _id: item.object });
            }
        },
        usernameToShow(item){
            if(item.owner && item.owner.alias){
                return item.owner.alias
            }else if(item.owner && item.owner.username){
                return item.owner.username
            }
        },
        
    },
};
</script>

<style scoped>
@import '../assets/css/project-changes.css';

</style>
